/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2021
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "Справа налево",
		"timeZoneID": "Часовой пояс",
		"skin": "Стиль",
		"metricsFileImportTask": "Новый импорт из файлов",
		"displayMode": "Стандартное представление",
		"credentialRenewed": "Ваши учетные данные обновлены с использованием вашего текущего ID пользователя и пароля.",
		"productLocale": "Язык продукта",
		"toggleDisabled": "выключен",
		"credentialChange": "Обновить",
		"log_level_Debug": "Отладка",
		"confirmNewPassword": "Подтвердите новый пароль",
		"unsavedViewMsg2": "Ваши изменения будут потеряны, если сначала вы их не сохраните.",
		"supportPortalErrorMessage": "Попробуйте еще раз.  Если ошибка повторится, обратитесь к администратору.",
		"legalText": "Лицензированные материалы - Собственность IBM Licensed Materials - Property of IBM Corp. © Copyright IBM Corporation and other(s) 2005, %{year}. IBM, логотип IBM, ibm.com и Cognos - товарные знаки или зарегистрированные товарные знаки International Business Machines Corp. во многих странах мира. Текущий список товарных знаков IBM можно найти в Интернете по адресу: www.ibm.com/legal/copytrade.shtml. Данная Программа предоставляется по лицензии на основании условий лицензионного соглашения, прилагаемого к Программе. Это лицензионное соглашение может находиться в папке или библиотеке каталога Программы, обозначенных как \"License\" или \"Non_IBM_License\", если это применимо, или предоставляться в виде печатного лицензионного соглашения. Перед тем, как воспользоваться Программой, внимательно прочтите лицензионное соглашение. Воспользовавшись Программой, вы тем самым примете эти условия.",
		"groupsAndRoles": "Группы и роли",
		"metricsMaintenanceTask": "Новое обслуживание",
		"email": "Электронная почта",
		"contextual": "Контекстное",
		"resetHome": "Восстановить значения по умолчанию",
		"ltr": "Слева направо",
		"credentials": "Учетные данные",
		"logging_congfig_title": "Ведение журнала",
		"changePasswordTitle": "Изменить мой пароль",
		"format": "Формат отчета",
		"showUnread": "Показать непрочитанное",
		"AILearning_active": "Обучение ИИ включено:",
		"docsErrorMessage": "Попробуйте еще раз.  Если ошибка повторится, обратитесь к администратору.",
		"toggleEnabled": "по",
		"homeSetError": "Произошла ошибка при установке используемой по умолчанию домашней страницы.",
		"passwordChange": "Изменить ваш пароль",
		"profile": "Профиль",
		"pdfRestricted": "PDF (Ограничено)",
		"drillThrough": "Определения детализации",
		"homeSet": "Ваша домашняя страница задана успешно",
		"regionalOptions": "Региональные параметры",
		"myPreferences": "Мои предпочтения",
		"defaultHome": "По умолчанию",
		"version": "Версия",
		"controller": "Controller",
		"manage": "Управление",
		"biDirectionalFeaturesEnabled": "Поддержка языков с двумя направлениями письма",
		"newFeaturesErrorTitle": "Связь с новыми возможностями не сработала",
		"passwordMatch": "Соответствие паролей",
		"updateProfileAndsettings": "Обновить профиль и настройки",
		"dashboardConsole": "Рабочее пространство",
		"legacyAppsSlideoutLabel": "Доступные прежние приложения",
		"logging_config_description": "Запись в журнал используется для поиска неисправностей. Обратитесь к своему администратору для руководства на настройке.",
		"confirmDeletion": "Подтвердить удаление",
		"signInButtonText": "Вход в систему",
		"dataSourceCredentials": "Идентификационные данные сервера данных",
		"AILearningConfigurationSlideoutAllyLabel": "Конфигурация обучения ИИ",
		"loadingSettings": "Загрузка настроек",
		"spreadsheetMLRestricted": "Excel (ограничено)",
		"manageAILearning": "Обучение ИИ",
		"xlsxDataRestricted": "Данные Excel (ограничено)",
		"advanced": "Дополнительные опции",
		"ok": "ОК",
		"changeEmail": "Изменить",
		"showHints": "Показать советы",
		"general": "Общие",
		"xlsxData": "Данные Excel",
		"newPassword": "Новый пароль",
		"hideAll": "Скрыть все",
		"confirmPassword": "Подтверждение пароля",
		"AILearning_config_description": "Улучшите рекомендации по продукту, позволив Cognos Analytics узнать, как вы его используете.",
		"metricStudio": "Studio (компонент)",
		"supportPortalErrorTitle": "Ссылка на портал поддержки не работает",
		"log_level_Warn": "Предупреждение",
		"contentSettings": "Настройки содержимого",
		"setHomeButton": "Задать",
		"myCapabilities": "Мои возможности",
		"homePage": "Домашняя страница",
		"helpErrorMessage": "Попробуйте еще раз.  Если ошибка повторится, обратитесь к администратору.",
		"loadingProfile": "Загрузка профиля",
		"portal": "Портал",
		"metricsPackage": "Новый пакет",
		"myCredentials": "Мои учетные данные",
		"credentialCreate": "Создать",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "Не удается обновить пароль",
		"showHiddenObjects": "Показать скрытые записи",
		"csv": "CSV",
		"docsErrorTitle": "Ссылка на документацию не работает",
		"log_level_Error": "Ошибка",
		"wrongPassword": "Не удается выполнить аутентификацию",
		"productName": "IBM Cognos Analytics %{version}",
		"log_level_Info": "Информация",
		"welcomeBanner": "Баннер с приветствием",
		"helpErrorTitle": "Ссылка на справку не работает",
		"contentLocale": "Язык содержимого",
		"pdf": "PDF",
		"oldPassword": "Прежний пароль",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "Специальные возможности",
		"manageLogging": "Ведение журнала",
		"loggingConfigurationSlideoutA11yLabel": "Конфигурирование записи в журнал",
		"communityErrorTitle": "Ссылка на сообщество не работает",
		"companionApps": "Сопутствующие приложения",
		"setHomeLabel": "Задать домашнюю страницу как (текущее представление)",
		"metricsExportTask": "Новый экспорт",
		"csvRestricted": "CSV (ограничено)",
		"newFeaturesErrorMessage": "Попробуйте еще раз.  Если ошибка повторится, обратитесь к администратору.",
		"contributor": "Contributor",
		"showAll": "Показать все",
		"logging_active": "Запись в журнал включена:",
		"html": "HTML",
		"profileAndSettings": "Профиль и настройки",
		"baseTextDirection": "Базовое направление текста",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "Пароль",
		"invalidEmail": "Введите действительный адрес электронной почты",
		"credentialCreateSuccess": "Вы успешно создали свои учетные данные",
		"settings": "Параметры",
		"restrictedFormatSelected": "У вас нет возможности запускать отчеты в этом формате, но вы можете получить доступ к отчетам, сохраненным в этом формате.",
		"usageDataDeletionConfirmation": "Удаление данных об использовании сбрасывает любое обучение ИИ.  Вы уверены, что хотите удалить данные об использовании?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "Просмотреть подробности",
		"deleteUsageData": "Удаление данных об использовании:",
		"showPassword": "Показать пароль",
		"AILearning_config_title": "Обучение ИИ",
		"myPreferencesSlideoutLabel": "Профиль и настройки",
		"passWordChangeSuccess": "Вы успешно изменили ваш пароль",
		"logging_level": "Уровень ведения журнала:",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "Попробуйте еще раз.  Если ошибка повторится, обратитесь к администратору.",
		"cancel": "Отмена",
		"shareSetError": "Данное действие не может быть выполнено перед закрытием и повторным открытием этого просмотра.",
		"passwordNotMatch": "Извините, пароль не совпадает",
		"xml": "XML",
		"xmlRestricted": "XML (Ограничено)",
		"openMenu": "Открыть меню",
		"closeMenu": 'Закрыть меню'
});